/**
 * Central endpoint definitions for the DEX transactions API: drives both the
 * request URLs and the MSW mock factories. `dexApiBaseQuery` points at the DEX
 * API root, so the paths carry the `/web` prefix.
 */
export const DEX_TRANSACTIONS_API_ENDPOINTS = {
  getListTransactions: {
    method: 'get',
    path: '/web/transactions/:pid/:tid/:success/:type/:limit/:page',
  },
  getServices: {
    method: 'get',
    path: '/web/services/:bId',
  },
} as const;
